import { SIGN_IN_FORM } from './SignInForm';
import { SIGN_UP_FORM } from './SignUpForm';
import { RESET_PASSWORD_FORM } from './ResetPasswordForm';
import * as actions from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { clickUserProfileLogout } from '../UserProfile/actions';

export interface IAuthState {
  readonly globalAuthFormErrors: any;
}

const initialState: IAuthState = {
  globalAuthFormErrors: {
    [SIGN_IN_FORM]: [],
    [SIGN_UP_FORM]: [],
    [RESET_PASSWORD_FORM]: [],
  },
};

type AuthFormErrors = ActionType<typeof actions> | ActionType<typeof clickUserProfileLogout>;

export default (state: Mutable<IAuthState> = initialState, action: AuthFormErrors): IAuthState => {
  switch (action.type) {
    case getType(actions.authSetGlobalFormErrors): {
      state.globalAuthFormErrors[action.payload.formName] = action.payload.errors;
      break;
    }
    case getType(actions.authClearGlobalFormErrors): {
      state.globalAuthFormErrors[action.payload] = initialState.globalAuthFormErrors[action.payload];
      break;
    }
    case getType(clickUserProfileLogout): {
      return initialState;
    }
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/containers/Auth/reducer.ts